var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.13807 7.50341C0.877721 7.25546 0.455611 7.25546 0.195262 7.50341C-0.0650878 7.75137 -0.0650878 8.15338 0.195263 8.40133L5.5286 13.4807C5.78895 13.7286 6.21106 13.7286 6.47141 13.4807L11.8047 8.40133C12.0651 8.15337 12.0651 7.75136 11.8047 7.50341C11.5444 7.25546 11.1223 7.25546 10.8619 7.50341L6.66667 11.4989L6.66666 0.968243C6.66666 0.617587 6.36819 0.333322 6 0.333322C5.63181 0.333322 5.33333 0.617587 5.33333 0.968243L5.33333 11.4989L1.13807 7.50341Z",
    fill: "#CC4747"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRed);
export default __webpack_public_path__ + "static/media/arrow-red.3905bc8bdee0752346ef2395f526912f.svg";
export { ForwardRef as ReactComponent };